
import * as yup from "yup";
import { useState, useEffect } from "react";
import { setupManagementUrl } from "../../../config";
import {
  executeDynamicSubmit,
  fetchJsonDynamic,
} from "../../../data/DynamicServiceNew/jsondynamicservice";
import DynamicForm from "../../../data/Axios/DynamicForm";
import {companyManagementUrl } from "../../../config";

const setup_url = companyManagementUrl.uri;

const Form = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [disbursementData, setDisbursmentDAta] = useState([]);
  const [loanding, setLoading] = useState("false");

  const initialValues = {
    EntryOrder: props.data ? props.data.EntryOrder : "",
    Setting: props.data ? props.data.Setting : "",
    Value: props.data ? props.data.Value : "",
  };

  const validationSchema = yup.object().shape({
    Value: yup.string().required("Value required"),
  });
  useEffect(() => {
    async function fetchAllData() {
      try {
        const data = await fetchJsonDynamic(
          "disbursmentLevel",
          "disbursmentLevel",
          null,
          setupManagementUrl.uri
        );
        setDisbursmentDAta(JSON.parse(data.results));
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchAllData();
  }, []);
  const setDropdownOpen = () => {
    setDropdownOpen(true);
  };
  const setDropdownClose = () => {
    setDropdownOpen(false);
  };

  // Create disbursement options array
  const disbursementOptions = disbursementData
    ? disbursementData.map((status) => ({
        parent_key: status.ID, // Correct syntax for creating an object
        label: status.Name,
        value: String(status.ID), // Use `String()` to ensure value is a string
      }))
    : []; // Default to an empty array if disbursementData is null/undefined

    const approvalOptions = [
      { true: 1 },
      { false: 2 }
    ];
  // Define fields array
  const fields = [
    props.data.Setting === "Disbursement LevelId"
      ? {
          name: "Value",
          label: "Value*",
          type: "select",
          options: disbursementOptions,
          required: true,
          parent: "main",
          gridColumn: "span 4",
        }
      : props.data.Value === "true" || props.data.Value === "false"
      ? {
          name: "Value",
          label: "Value*",
          type: "select",
          options: [
            { label: "True", value: "true" },
            { label: "False", value: "false" },
          ],
          required: true,
          gridColumn: "span 2",
        }
      : {
          name: "Value",
          label: "Value*",
          type: "text",
          required: true,
          gridColumn: "span 2",
        },
  ];
  
  const handleSubmit = async (values, { setSubmitting }) => {
    const { Value } = values;
    const variables = { id: props.data.Id, value: Value };

    await executeDynamicSubmit({
      mutationName: "updateCompanySettings",
      variables,
      mutationObjectName: "companySettings",
      baseUrl: setup_url,
      isEditing: props.isEditing,
      entityName: "Company Settings",
      onSuccess: () => {
        props.onClose();
        props.onAction();
      },
      setSubmitting,
    });
  };
  console.log("disbursementData:", disbursementData);

  return (
    <DynamicForm
      fields={fields}
      onSubmit={handleSubmit}
      title={`Edit ${props.data.Setting}`}
      subtitle={`Edit ${props.data.Setting}`}
      initialValues={initialValues}
      //   onFieldChange={onFieldChange}
    />
  );
};
export default Form;